import api from "../../../lib/api";

export default {
  putSettingsChanges(data) {
    return api({
      endpoint: "settings",
      path: "my-contents",
      method: "PUT",
      body: data
    });
  },
  deleteContents(data) {
    return api({
      endpoint: "delete",
      path: "my-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postUpdatedContentsThumbnail(data) {
    return api({
      endpoint: "updated-contents-thumbnail",
      path: "my-contents",
      method: "POST",
      body: data
    });
  },
  deleteUpdatedContentsThumbnail(data) {
    return api({
      endpoint: "updated-contents-thumbnail",
      path: "my-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postUpdatedContentsThumbnailComplete(data) {
    return api({
      endpoint: "updated-contents-thumbnail-complete",
      path: "my-contents",
      method: "POST",
      body: data
    });
  },
  postUpdatedSocialMediaImage(data) {
    return api({
      endpoint: "updated-social-media-image",
      path: "my-contents",
      method: "POST",
      body: data
    });
  },
  deleteUpdatedSocialMediaImage(data) {
    return api({
      endpoint: "updated-social-media-image",
      path: "my-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postUpdatedSocialMediaImageComplete(data) {
    return api({
      endpoint: "updated-social-media-image-complete",
      path: "my-contents",
      method: "POST",
      body: data
    });
  },
  putExternalClients(data) {
    return api({
      endpoint: "external-clients",
      path: "my-contents",
      method: "PUT",
      body: data
    });
  },
  deleteExternalClients(data) {
    return api({
      endpoint: "external-clients",
      path: "my-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  postContentsAddLink(data) {
    return api({
      endpoint: "contents-links",
      path: "my-contents",
      method: "POST",
      body: data
    });
  },
  putContentsAddLink(data) {
    return api({
      endpoint: "contents-links",
      path: "my-contents",
      method: "PUT",
      body: data
    });
  },
  deleteContentsAddLink(data) {
    return api({
      endpoint: "contents-links",
      path: "my-contents",
      method: "DELETE",
      queryParams: data
    });
  },
  putContentsLinkSettings(data) {
    return api({
      endpoint: "contents-link-settings",
      path: "my-contents",
      method: "PUT",
      body: data
    });
  },
  putContentsLinkSettingsPreview(data) {
    return api({
      endpoint: "contents-link-settings-preview",
      path: "my-contents",
      method: "PUT",
      body: data
    });
  },
  postDraftContentsLinkSettings(data) {
    return api({
      endpoint: "draft-contents-link-settings",
      path: "my-contents",
      method: "POST",
      body: data
    });
  }
};
